import { useState, useEffect, useRef, useMemo } from "react"
import { useNavigate } from "react-router-dom"
import { toast } from 'react-toastify'
import Server from "../../Shared/Server"
import Spinner from '../../Shared/Spinner'
import { years_list, months_list } from "../../Shared/List";
import SelectField from "../../Shared/SelectField";
import { FaFileExport } from "react-icons/fa"
import {AgGridReact} from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const ExpenseSummary = (props) => {
    const current_user = JSON.parse(localStorage.getItem('user'))
    const billing_date  = current_user?.branch?.billing_date
    const [errors, setErrors] = useState([]);
    const [expenses, setExpenses] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const gridRef = useRef();
    const [yearOptions, setYearOptions] = useState([]);
    const [monthOptions, setMonthOptions] = useState([]);
    const [pinnedBottomRowData, setPinnedBottomRowData] = useState([]);
    const [title, setTitle] = useState('');
    const [formData, setFormData] = useState({
        year: billing_date.year,
        month: billing_date.month,
    });
    const {year, month} = formData;

    const navigate = useNavigate()

    useEffect(() => {

        const years = []
        const months = []
        years_list.map(year => (
            years.push({
                id: year.id,
                name: year.name,
                key: year.key
            })
        ))

        months_list.map(month => (
            months.push({
                id: month.id,
                name: month.name,
                key: month.key
            })
        ))

        setYearOptions(years)
        setMonthOptions(months)
        
        fetchData()
    }, [])

    const [columnDefs] = useState([
        {
            headerName: "#",
            filter: false,
            maxWidth: 70,
            sortable: true,
            valueFormatter: function (params) {
            if (isNaN(params.node.id)) {
                return "";
            }
            return `${Number(params.node.rowIndex) + 1}`;
            },
        },
        
        {
            headerName: "Category",
            field: "name",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Debit",
            field: "debit",
            sortable: true,
            filter: 'agNumberColumnFilter',
        },
        {
            headerName: "Credit",
            field: "credit",
            sortable: true,
            filter: 'agNumberColumnFilter',
        },
    ]);

    const fetchData = async () => {
        setTitle(`${months_list[month - 1].name}, ${year} Expenses`)
        setIsLoading(true)
        try {
            const response = await Server.get(`/expenses/?year=${year}&month=${month}`)
            setExpenses(response?.data);
            setIsLoading(false);

            const output = response?.data.reduce((data, row) => {
                data.debit += parseFloat(row.debit);
                data.credit += parseFloat(row.credit);
                return data;
            }, {debit: 0.00, credit: 0.00});
            setPinnedBottomRowData([
                {
                    debit: parseFloat(output.debit).toFixed(2),
                    credit: parseFloat(output.credit).toFixed(2),
                }
            ]);
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                localStorage.removeItem('user')
                navigate('/login')
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error.response.data)
            }
        }
    }

    const onChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value
        }))
    }

    const onSubmit = (e) => {
        e.preventDefault()
        
        fetchData()
    }

    const onDoubleClick = (payload) => {
        navigate('/expense-detail', { state: {payload: payload}})
    }

    let gridApi

    const onGridReady=(params)=>{
        gridApi=params.api
    }
      const onExportClick=()=>{
        gridApi.exportDataAsCsv({ fileName: `${title}.csv` })
    }

    const getRowStyle = (params) => {
        if (params.node.rowPinned) {
          return {
            backgroundColor: '#f8f9fa',
            fontWeight: 'bold',
            color: '#000',
          };
        }
        return {};
    };

    const defaultColDef = useMemo(() => {
        return {
            filterParams: {
                buttons: []
            }
        };
    }, []);

    const onFirstDataRendered = (params) => {
        params.api.autoSizeAllColumns();
    }

    const onGridSizeChanged = (params) => {
        params.api.autoSizeAllColumns();
    }

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <form onSubmit={onSubmit}>
            <div className="row">
                <div className="col-md-2">
                    <SelectField
                        name="year"
                        value={parseInt(year)}
                        options={yearOptions}
                        onChange={onChange}
                        error={errors.year}
                    />
                </div>
                <div className="col-md-2">
                    <SelectField
                        name="month"
                        value={parseInt(month)}
                        options={monthOptions}
                        onChange={onChange}
                        error={errors.month}
                    />
                </div>
                <div className="col-md-7">
                    <input type="submit" className="btn btn-info mt-1" value="Apply Filter" style={{float: 'left'}}/>
                </div>
                <div className="col-md-1">
                    <button onClick={()=>onExportClick()} className="btn btn-success mb-2" style={{float: 'right'}}><FaFileExport/> &nbsp;Export</button>
                </div>
            </div>
            <br/>
        </form>
        <div className="card">
    
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">{title}</h3>
            </div>
            <div className="card-body">
            <div className="row">
                <div className="col-md-12">
                    <div className="ag-theme-alpine responsive-aggrid" style={{ height: 400, width: '100%' }}>
                        <AgGridReact
                            onRowDoubleClicked={(e) => {
                                if (e.node.rowPinned) return '';
                                if (e.data.customers < 1) return '';
                                
                                onDoubleClick({year: parseInt(year), month: parseInt(month), public_id: e.data.public_id, name: e.data.name})
                            }}
                            defaultColDef={defaultColDef}
                            onFirstDataRendered={onFirstDataRendered}
                            onGridSizeChanged={onGridSizeChanged}
                            suppressMenuHide={true}
                            rowData={expenses}
                            domLayout={"normal"}
                            rowSelection={"multiple"}
                        
                            pagination={false}
                            onGridReady={onGridReady}
                        
                            resizable={true}
                            animateRows={true}
                            enableCellTextSelection={true}
                            suppressCellFocus={true}
                        
                            ref={gridRef}
                            pinnedBottomRowData={pinnedBottomRowData}
                            getRowStyle={getRowStyle}
                            columnDefs={columnDefs}
                        ></AgGridReact>{" "}
                    </div>
                </div>
            </div>
        </div>
    </div>
      <br/>
    </>
  )
}

export default ExpenseSummary
